import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useIsProfileInitialized, useProfileStore } from '@/store/profileStore';
import { usertourService } from '@/services/usertour.service';
import { getNowIso } from '@/utils/datetime';

export function useUsertourIdentity() {
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const userEmail = useAuthStore((s) => s.user?.email ?? null);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const profileCount = useProfileStore((s) => s.profiles.length);
  const selectedProfileId = useProfileStore((s) => s.selectedProfileId);
  const isProfileInitialized = useIsProfileInitialized();

  useEffect(() => {
    if (!isAuthenticated || !userId || !isProfileInitialized) {
      return;
    }

    const nowIso = getNowIso();

    usertourService.identify(userId, {
      ...(userEmail ? { email: userEmail } : {}),
      role: 'B2B',
      profile_count: profileCount,
      selected_profile_id: selectedProfileId ? String(selectedProfileId) : '',
      signed_up_at: nowIso,
      last_seen_at: nowIso,
    });
  }, [isAuthenticated, userId, userEmail, isProfileInitialized, profileCount, selectedProfileId]);
}
